<template>
  <div id="post_container" @click="nav_to_article">
    <div id="post">
      <img :src="post_img_compact(post)" id="post_img" />

      <div id="post_subcontainer">
        <h4>{{post.title}}</h4>
        <p>{{post.summary}}</p>

        <div id="spacer">&nbsp;</div>

	<div id="read_more_container">
          <router-link :to="'/post/' + post.path" id="read_more">
            Read More
            <img src="@/assets/imgs/new_arrow-right.svg" style="width: 16px"/>
          </router-link>
	</div>
      </div>
    </div>
  </div>
</template>

<script>
import HasPost   from "@/mixins/HasPost"

export default {
  name: "ArticleItem",

  mixins: [
    HasPost
  ],

  methods: {
    nav_to_article: function () {
      this.$router.push(`/post/${this.post.path}`)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#post_container{
  background-image: linear-gradient($grey-5-alpha75, $black-alpha75 50%);
  border: 1px solid $grey-5;
  border-radius: 15px;
  width: 30%;
  height: 500px;
  padding: 5px;
  cursor: pointer;
}

#main_layout_v2.md #post_container{
  width: 47%;
}

#main_layout_v2.sm #post_container{
  width: 60%;
  margin-bottom: 15px;
}

#main_layout_v2.xs #post_container{
  width: unset;
  margin-bottom: 15px;
}

#post{
  border-radius: 15px;
  height: 100%;
}

#post_img{
  width: 100%;
  height: 150px;
  border-radius: 15px 15px 0 0;
}

#post_subcontainer{
  background-image: linear-gradient($black-alpha75, $black);
  border-radius: 15px 15px 0 0;
  padding: 20px 20px 0 20px;
  position: relative;
  top: -10px;
  height: 70%;
  display: flex;
  flex-direction: column;
  font-family: Alliance No2;
}

#post_subcontainer h4{
  font-family: Sunset Gothic Pro Heavy;
}

#main_layout_v2.lg #post_subcontainer h4{
  font-size: 1.25rem;
}

#main_layout_v2.xs #post_subcontainer h4{
  font-size: 1.1rem;
}

#spacer{
  flex-grow: 1;
  border-bottom: 1px solid $grey-2;
}

#read_more_container{
  align-self: end;
  padding-top: 10px;
  padding-bottom: 5px;
}

#read_more{
  border-bottom: 1px solid $sunset-coral;
  color: $white;
  width: fit-content;
  display: flex;
}

#read_more:hover{
  text-decoration: none;
}

#read_more img{
  margin-left: 5px;
}
</style>
